import { Component, OnInit, OnDestroy } from "@angular/core";
import { FormControl, FormBuilder, FormGroup } from "@angular/forms";
import {
  IntCustomFieldConfig,
  SharedModule,
  FormInputComponent,
  CurrencyCode,
  DataService,
} from "@bb-vendure/admin-ui/core";
import { Observable, tap, map, combineLatest } from "rxjs";

interface PriceCurrency {
  price: number;
  currencyCode: string;
}

@Component({
  selector: "multiple-currency-form-input",
  standalone: true,
  templateUrl: "./multiple-currency-form-input.component.html",
  styleUrl: "./multiple-currency-form-input.component.scss",
  imports: [SharedModule],
})
export class MultipleCurrencyFormInputComponent
  implements FormInputComponent, OnInit
{
  readonly: boolean;
  config: IntCustomFieldConfig;
  formControl: FormControl<string[]>;
  isListInput?: boolean | undefined = true;
  unusedCurrencyCodes$: Observable<string[]>;

  pricesForm = this.formBuilder.array<
    FormGroup<{
      price: FormControl<number | null>;
      currencyCode: FormControl<CurrencyCode | null>;
      delete: FormControl<boolean | null>;
    }>
  >([]);

  constructor(
    private formBuilder: FormBuilder,
    private dataService: DataService
  ) {}
  ngOnInit(): void {
    if (this.formControl.value.length > 0) {
      for (const v of this.formControl.value) {
        const currencyPrice = this.stringToPriceCurrency(v);

        this.pricesForm.push(
          this.formBuilder.group({
            currencyCode: currencyPrice?.currencyCode!,
            price: currencyPrice?.price!,
            delete: false as boolean,
          })
        );
      }
    }

    const availableCurrencyCodes$ = this.dataService.settings
      .getActiveChannel()
      .single$.pipe(
        map((data) => {
          console.log("currency", data);

          if (this.formControl.value.length <= 0) {
            this.addPriceInCurrency(data.activeChannel.defaultCurrencyCode);
          }

          return Array.from(new Set(data.activeChannel.availableCurrencyCodes));
        })
      );
    this.unusedCurrencyCodes$ = combineLatest([
      this.pricesForm.valueChanges,
      availableCurrencyCodes$,
    ]).pipe(
      map(([prices, currencyCodes]) => {
        console.log("prices", prices);
        console.log("cur", currencyCodes);

        return currencyCodes.filter(
          (code) => !prices.map((p) => p.currencyCode).includes(code)
        );
      })
    );

    console.log({ formControl: this.formControl });
  }

  addPriceInCurrency(currencyCode: CurrencyCode) {
    this.pricesForm.push(
      this.formBuilder.group({
        currencyCode,
        price: 0,
        delete: false as boolean,
      })
    );
    this.formControl.patchValue([
      ...this.formControl.value,
      this.priceCurrencyToString(0, currencyCode),
    ]);
  }

  // Because custom form input does not allow object type so we have to store {price, currencyCode} in string type
  // Ex:  {price : 100,currencyCode : 'CNY'} => CNY#100
  priceCurrencyToString(price: number, currencyCode: CurrencyCode) {
    return `${currencyCode}#${price}`;
  }

  stringToPriceCurrency(value: string) {
    const arr = value.split("#");

    if (arr.length !== 2) {
      return null;
    }

    return {
      price: +arr[1],
      currencyCode: arr[0] as CurrencyCode,
    };
  }

  delete(currencyCode: CurrencyCode) {
    const formInputIndex = this.pricesForm.value.findIndex(
      (v) => v.currencyCode === currencyCode
    );

    this.pricesForm.removeAt(formInputIndex);
    const arrValue = this.formControl.value;
    const newArrValue = arrValue.filter((v, i) => i !== formInputIndex);
    this.formControl.patchValue(newArrValue);
  }

  changePriceCurrency(currencyCode: CurrencyCode, value: number) {
    const arrValue = this.formControl.value;
    const formInputIndex = this.pricesForm.value.findIndex(
      (v) => v.currencyCode === currencyCode
    );
    const priceCur = this.stringToPriceCurrency(arrValue[formInputIndex]);

    if (priceCur) {
      priceCur.price = value;

      const newValue = this.priceCurrencyToString(
        priceCur.price,
        priceCur.currencyCode
      );

      arrValue[formInputIndex] = newValue;
      this.formControl.patchValue(arrValue);
    }
  }
}
